export default __webpack_public_path__ + "static/part1_5-9a026b477c32b20c8bda443289fe22e5.png";